import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Switch,
  Typography,
  Divider,
  CircularProgress,
  Box,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import NotifyService from 'services/NotifyService';

const DEFAULTS = {
  as_email: false,
  as_push: true,
  on_photo_comment: true,
  on_project_comment: true,
};

const NotificationSettings = ({ open, onClose }) => {
  const [prefs, setPrefs] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open) {
      loadPreferences();
    }
  }, [open]);

  const loadPreferences = async () => {
    setLoading(true);
    const res = await NotifyService.getPreferences();
    if (res?.status === 'success' && res.data) {
      setPrefs({
        as_email: !!res.data.as_email,
        as_push: !!res.data.as_push,
        on_photo_comment: !!res.data.on_photo_comment,
        on_project_comment: !!res.data.on_project_comment,
      });
    }
    setLoading(false);
  };

  const handleToggle = async (key, value) => {
    setPrefs((prev) => ({ ...prev, [key]: value }));
    await NotifyService.updatePreferences({ [key]: value });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 0 }}>
        <Typography variant="h6" style={{ fontWeight: 600 }}>
          Notification Settings
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 8 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress size={32} style={{ color: '#FF844B' }} />
          </Box>
        ) : (
          <>
            <Typography
              variant="subtitle2"
              style={{ fontWeight: 700, marginTop: 8, marginBottom: 4, color: '#0D3F67' }}
            >
              I'd like to receive notifications...
            </Typography>
            <Divider />
            <List disablePadding>
              <ListItem>
                <ListItemText primary="As emails" />
                <Switch
                  checked={prefs.as_email}
                  onChange={(e) => handleToggle('as_email', e.target.checked)}
                  color="primary"
                />
              </ListItem>
              <Divider variant="inset" component="li" />
              <ListItem>
                <ListItemText primary="As push notifications" />
                <Switch
                  checked={prefs.as_push}
                  onChange={(e) => handleToggle('as_push', e.target.checked)}
                  color="primary"
                />
              </ListItem>
            </List>

            <Typography
              variant="subtitle2"
              style={{ fontWeight: 700, marginTop: 16, marginBottom: 4, color: '#0D3F67' }}
            >
              Send me notifications when someone...
            </Typography>
            <Divider />
            <List disablePadding>
              <ListItem>
                <ListItemText primary="Comments on photos I've taken" />
                <Switch
                  checked={prefs.on_photo_comment}
                  onChange={(e) => handleToggle('on_photo_comment', e.target.checked)}
                  color="primary"
                />
              </ListItem>
              <Divider variant="inset" component="li" />
              <ListItem>
                <ListItemText primary="Comments on photos/projects I've commented on" />
                <Switch
                  checked={prefs.on_project_comment}
                  onChange={(e) => handleToggle('on_project_comment', e.target.checked)}
                  color="primary"
                />
              </ListItem>
            </List>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default NotificationSettings;
